import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PayForm from '../../followup/components/PayForm';
import { bindActionCreators } from 'redux';
import { choosePaymentMethod, fetchCreditCardFields } from '../../../data/followup/actions/followup';
import { getPaymentMethod, getPayIsFetching, getCreditCardFields } from '../../../data/followup/selectors/followup';
import * as paymentMethods from '../../../data/followup/constants/payment_methods';
import CreditCardForm from "../components/CreditCardForm";
import BankTransferForm from "../components/BankTransferForm";
import CheckBookForm from "../components/CheckBookForm";

class PayFormContainer extends Component {
    static propTypes = {
        isFetching: PropTypes.bool,
        paymentMethod: PropTypes.string,
        choosePaymentMethod: PropTypes.func,
        fetchCreditCardFields: PropTypes.func,
        creditCardFields: PropTypes.object
    };

    tabs = [
        { name: paymentMethods.methodName(paymentMethods.CREDIT_CARD), href: paymentMethods.CREDIT_CARD},
        { name: paymentMethods.methodName(paymentMethods.BANK_TRANSFER), href: paymentMethods.BANK_TRANSFER },
        { name: paymentMethods.methodName(paymentMethods.CHECK_BOOK), href: paymentMethods.CHECK_BOOK },
    ]

    componentDidMount() {
        this.props.fetchCreditCardFields();
    }

    handleChooseMethod(method) {
        this.props.choosePaymentMethod(method);
    }

    render() {
        const { paymentMethod, isFetching } = this.props;

        return (
            <PayForm
                isFetching={isFetching}
                method={paymentMethod}
                tabs={this.tabs}
                onChooseMethod={::this.handleChooseMethod}
            >
                {this.renderMethodForm()}
            </PayForm>
        );
    }

    renderMethodForm() {
        const { paymentMethod, creditCardFields } = this.props;

        switch (paymentMethod) {
            case paymentMethods.CREDIT_CARD:
                return <CreditCardForm fields={creditCardFields} />;

            case paymentMethods.BANK_TRANSFER:
                return <BankTransferForm />;

            case paymentMethods.CHECK_BOOK:
                return <CheckBookForm />;
        }

        return null;
    }
}

export default connect(
    state => ({
        paymentMethod: getPaymentMethod(state.followup),
        isFetching: getPayIsFetching(state.followup),
        creditCardFields: getCreditCardFields(state.followup)
    }),
    dispatch => bindActionCreators({ choosePaymentMethod, fetchCreditCardFields }, dispatch)
)(PayFormContainer);
